import {Component, Input, OnInit} from '@angular/core';
import {notify, Vehicle} from 'shared';
import {TractorService} from '../../stores/tractor.service';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {Settings, SettingsService} from '../../settings/settings.service';
import DataSource from 'devextreme/data/data_source';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-vehicles-icon-selector',
  templateUrl: './vehicles-icon-selector.component.html',
  styleUrls: ['./vehicles-icon-selector.component.scss']
})
export class VehiclesIconSelectorComponent implements OnInit {

  ds: DataSource;

  @Input()
  item: Vehicle;
  visible: boolean;
  loadIndicatorVisible: boolean;

  constructor(private settings: Settings,
              private settingsService: SettingsService,
              private tractorService: TractorService,
              private domSanitizer: DomSanitizer) {
    this.save = this.save.bind(this);
    this.close = this.close.bind(this);

    this.ds = settingsService.settingListDataSource(settings, 'vehicles_icons', 'id');
  }

  ngOnInit(): void {
  }

  changeIcon(vehicle: Vehicle) {
    this.item = vehicle;
    this.visible = true;
  }

  save() {
    this.loadIndicatorVisible = true;
    this.tractorService.saveSettings(this.item).pipe(catchError((error) => {
      this.loadIndicatorVisible = false;
      return throwError(error);
    })).subscribe(_ => {
      notify('Icon mis à jour avec succès');
      this.loadIndicatorVisible = false;
      this.visible = false;
    });
  }

  close() {
    this.visible = false;
  }

  safeUrl(rawUrl: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(rawUrl);
  }

  onRowInserting(e: any) {
    e.data.id = Date.now();
  }
}
